/*
OHVANI Luxury Storefront Template v0.0.2
Owned by OHVANI / ATELIER Group. Created for OHVANI.com.
Unauthorized resale, redistribution, or reuse as a commercial theme is not permitted.
*/
document.addEventListener('DOMContentLoaded', function(){
  var toggle = document.querySelector('[data-mobile-toggle]');
  var panel = document.querySelector('[data-mobile-panel]');
  if(toggle && panel){
    toggle.addEventListener('click', function(){
      var open = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-product-variant-select]').forEach(function(select){
    select.addEventListener('change', function(){
      var option = select.options[select.selectedIndex];
      var sku = option.getAttribute('data-sku');
      var price = option.getAttribute('data-price');
      var skuTarget = document.querySelector('[data-selected-sku]');
      var priceTarget = document.querySelector('[data-selected-price]');
      if(skuTarget && sku){ skuTarget.textContent = sku; }
      if(priceTarget && price){ priceTarget.textContent = price; }
    });
  });
});
